import Icon, { BaseIconProps } from './Icon'
function ShareIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 13 18"
        {...props}
      >
        <path d="M1.23 18A1.27 1.27 0 0 1 0 16.77V6.36c.02-.67.56-1.21 1.23-1.23h3.46v1.23H1.23v10.41h10.64V6.36h-3.5V5.13h3.5c.67.02 1.21.56 1.23 1.23v10.41A1.27 1.27 0 0 1 11.87 18zm4.68-6.28V2.37l-1.8 1.8-.88-.88L6.52 0l3.29 3.29-.87.88-1.8-1.8v9.35z" />
      </svg>
    </Icon>
  )
}
export default ShareIcon
